// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";

// --- DEBUG: detector de WebChannel (pegarlo PRIMERO) ---

// --- IMPORT TEMPRANO: garantiza que tu instancia Firestore (con FetchStreams)
//     se inicialice antes que cualquier Provider/Hooks que creen listeners.
import "./firebase"; // <- importa tu init (exporta db, etc.)

import "./index.css";
import App from "./App.jsx";
import "semantic-ui-css/semantic.min.css";
import "./scss/global.scss";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import generateStore from "./redux/store";
import { Theme } from "./Theme/Theme";
//import UsuarioProvider from "./context/UsuarioProvider";
import UserContext from "./context/CurrentUserProvider";

// (Opcional) si quieres correr el probe de transporte:
// import { runFirestoreTransportProbe } from "./firebase";
// runFirestoreTransportProbe();

const store = generateStore();
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <UserContext>
        <ThemeProvider theme={Theme}>
          <App />
        </ThemeProvider>
      </UserContext>
    </Provider>
  </React.StrictMode>
);
